import * as Api from "../api/deposit.js";

export const getDeposits = async (token, id, callback) => {
	try {
		const { data } = await Api.getDeposits(token, id);
		callback(data);
	} catch (error) {
		console.log("getDeposits error", error);
	}
};

export const getDepositsAgent = async (token, id, callback) => {
	try {
		const { data } = await Api.getDepositsAgent(token, id);
		callback(data);
	} catch (error) {
		console.log("getDeposits error", error);
	}
};

export const getAddressByCryptoCurrencyNetworkAgent = async (token, cryptoCurrency, network, callback) => {
	try {
		const { data } = await Api.getAddressByCryptoCurrencyNetworkAgent(token, cryptoCurrency, network);
		callback(data);
	} catch (error) {
		console.log("getDeposits error", error);
	}
};
